export default "/assets/people_no_results-f4f95e1a72730c4f6713bed7a4b3e7def8881718e4ead12b40dd7858743e8583.svg";